import { css } from 'linaria';

export const authorBlock = css`
  display: flex;
  flex-direction: column;
`;

export const firstRow = css``;

export const authorContainer = css`
  display: flex;
  align-items: center;
`;

export const personTitle = css`
  margin-inline-start: 12px;
`;

export const ratingWrapper = css`
  display: flex;
  align-items: center;
`;

export const textRow = css`
  display: flex;
`;

export const textRowProsCons = css`
  display: flex;
  flex-flow: row wrap;
`;

export const prosConsLabel = css`
  flex-shrink: 0;
  padding-right: 4px;
`;

export const prosConsContent = css`
  display: flex;
  flex-grow: 1;
  flex-shrink: 0;
  max-width: 100%;
  margin: 0;
`;

export const likeDislikeGroupWrapper = css`
  margin-top: var(--space-50);
`;

export const reviewAdditionalInfoWrapper = css`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--space-100);
`;

export const reviewAdditionalWrapper = css`
  display: flex;
  flex-direction: column;
  gap: var(--space-50);
  margin-bottom: var(--space-50);
`;

export const labelStyles = css`
  padding: var(--space-60) var(--space-35);
  height: var(--space-225);
  border-radius: var(--space-25);
`;

export const typographyStyles = css`
  margin: 0;
`;

export const reviewVariantNotPointer = css`
  cursor: auto;
  color: var(--text-primary);
`;
